export const basePath =
  process.env.NODE_ENV === "development" ? "" : "/react-lingui-example";
